import React from 'react';
import PropTypes from 'prop-types';

import GenericTextInputField from '../../commons/form-fields/GenericTextInputField';
import { CURRENCY } from '../../commons/Constants';

const ConsultantInvoiceBasicDetailsSection = (props) => {
    const currencySymbol = CURRENCY[props.currency].symbol;
    const billingRateLabel = `Billing Rate (${currencySymbol}/hour)`;
    const totalAmountLabel = `Total Amount (${currencySymbol})`;

    return (
        <div>
            <GenericTextInputField
                name="consultantName"
                label="Full Name"
                type="text"
                disabled={true}
            />
            <GenericTextInputField
                name="dateOfConsultation"
                label="Date of Consultation (in ET)"
                type="text"
                disabled={true}
            />
            <GenericTextInputField
                name="repeatConsultant"
                label="Previously Consulted"
                type="text"
                disabled={true}
            />
            <div className="md:flex">
                <div className="md:w-1/2 md:pr-1">
                    <GenericTextInputField
                        name="callDuration"
                        label="Call Duration (in minutes)"
                        type="number"
                        required={true}
                    />
                </div>
                <div className="md:w-1/2 md:pl-1">
                    <GenericTextInputField
                        name="consultantInvoiceRateOfCompensation.billingRate"
                        label={billingRateLabel}
                        type="text"
                        disabled={true}
                    />
                </div>
            </div>
            <GenericTextInputField
                name="totalAmount"
                label={totalAmountLabel}
                type="text"
                disabled={true}
            />
        </div>
    );
};

ConsultantInvoiceBasicDetailsSection.propTypes = {
    currency: PropTypes.string,
};

export default ConsultantInvoiceBasicDetailsSection;
